import { render, staticRenderFns } from "./AccountVerificationWarning.vue?vue&type=template&id=3893b7b0&scoped=true&"
import script from "./AccountVerificationWarning.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationWarning.vue?vue&type=script&lang=js&"
import style0 from "./AccountVerificationWarning.vue?vue&type=style&index=0&id=3893b7b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3893b7b0",
  null
  
)

export default component.exports